/**
 * Carousel Block — view.js
 *
 * Loaded on the front-end ONLY when at least one Parasole Carousel block
 * is present on the page (WordPress handles this via the viewScript field
 * in block.json).
 *
 * Swiper CSS + JS and Fancybox CSS + JS are enqueued conditionally by the
 * PHP render callback (see carousel.php) so they are guaranteed to be
 * available here as globals (`Swiper` and `Fancybox`).
 *
 * Author: Paul Stroot
 * Text Domain: parasole
 */

(function () {
	"use strict";

	// Default Swiper parameters — mirrors the editor defaults in index.js
	const DEFAULT_SWIPER_PARAMS = {
		loop: true,
		autoHeight: true,
		slidesPerView: "auto",
		loopedSlides: 3,
		spaceBetween: 16,
		autoplay: {
			delay: "3000",
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	};

	function initCarousels() {
		const carousels = document.querySelectorAll(
			".parasole-carousel-block .parasole-carousel-container",
		);

		if (!carousels.length) return;

		carousels.forEach(function (container) {
			const swiperEl = container.querySelector(".swiper");
			if (!swiperEl) return;

			// Determine params: use custom JSON if provided, otherwise defaults
			let params = Object.assign({}, DEFAULT_SWIPER_PARAMS);

			const rawCustom = container.dataset.customParams;
			if (rawCustom && rawCustom.trim()) {
				try {
					const custom = JSON.parse(rawCustom);
					params = custom;
				} catch (e) {
					console.warn(
						"[Parasole Carousel] Could not parse custom Swiper params, falling back to defaults.",
						e,
					);
				}
			}

			// Scope navigation/pagination selectors to this specific container
			// so multiple carousels on one page don't share controls.
			if (params.navigation) {
				params.navigation = {
					nextEl: container.querySelector(".swiper-button-next"),
					prevEl: container.querySelector(".swiper-button-prev"),
				};
			}
			if (params.pagination) {
				params.pagination = Object.assign(
					{},
					typeof params.pagination === "object" ? params.pagination : {},
					{
						el: container.querySelector(".swiper-pagination"),
						clickable: true,
					},
				);
			}

			new Swiper(swiperEl, params); // eslint-disable-line no-undef

			// ── Fancybox lightbox ──────────────────────────────────────────────
			// Build the gallery from real (non-duplicate) slides only, so Swiper's
			// loop clones don't appear as extra items in the lightbox.
			const realFigures = Array.from(
				swiperEl.querySelectorAll(
					".swiper-slide:not(.swiper-slide-duplicate) .carousel-figure",
				),
			);

			const galleryItems = realFigures.map(function (fig) {
				return {
					src: fig.dataset.displayUrl,
					caption: fig.dataset.caption || "",
					type: "image",
				};
			});

			// Attach click handler to every figure (including Swiper clones) so
			// the lightbox opens regardless of which copy of the slide is visible.
			swiperEl
				.querySelectorAll(".carousel-figure")
				.forEach(function (fig) {
					// Cloned figures share the same display URL; map to the real index.
					const startIndex = realFigures.findIndex(
						(real) => real.dataset.displayUrl === fig.dataset.displayUrl,
					);

					fig.addEventListener("click", function () {
						Fancybox.show(galleryItems, { // eslint-disable-line no-undef
							startIndex: startIndex >= 0 ? startIndex : 0,
						});
					});
				});
		});
	}

	// Run after DOM is ready
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () {
			initCarousels();
		});
	} else {
		initCarousels();
	}
})();
